<template>
  <input
    ref="inputRef"
    type="number"
    class="login-tfa-number-cell"
    :class="{
      'login-tfa-number-cell--active': active,
    }"
    :min="0"
    :max="9"
    :value="sanitizedCellValue"
    aria-label="Two-factor authentication code digit"
  />
</template>

<script lang="ts">
export default {
  name: 'LoginTfaNumberCell',
}
</script>

<script setup lang="ts">
import type { PropType } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'

const props = // eslint-disable-next-line vue/define-props-declaration
  defineProps({
    value: { required: true, type: null as unknown as PropType<number | null> },
    active: { required: true, type: Boolean },
  })

const inputRef = ref<HTMLInputElement>()

const sanitizedCellValue = computed((): string | null =>
  props.value === null ? '' : props.value.toString(),
)

const onActive = (): void => {
  setFocusIfActive()
}

const setFocusIfActive = (): void => {
  if (!props.active) {
    return
  }
  if (!inputRef.value) {
    return
  }
  inputRef.value.focus()
}
watch(() => props.active, onActive, { immediate: true })

onMounted((): void => {
  setFocusIfActive()
})
</script>

<style lang="scss" scoped>
@import '@/uiKit/assets/colors.global.scss';

.login-tfa-number-cell {
  @include row--center;
  width: 40px;
  height: 56px;
  border-radius: 10px;
  background: var(--color-background-gray-subtlest);
  @include typography(xl-1, inter);
  text-align: center;
  // CSS trick to hide the caret and show text only
  color: transparent;
  text-shadow: 1px 0 0 $color90Black;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
}

.login-tfa-number-cell--active {
  border: 1px solid var(--color-border-focused);
  border-radius: 10px;
}
</style>
